export default "assets/images/icons/marker-9190790c.svg";